<div class="h-screen bg-ground">
  <router-outlet></router-outlet>
  <p-toast [life]="3000"></p-toast>
</div>
